import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Button } from "react-bootstrap";
import "../../styles/depots/depots.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import DepotMap from "../maps/depotMap";
import HtmlContent from "../commoncomponents/htmlContent";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { searchSuggestionAPI, GeoCodeAPI } from "../../utils/mapapi";
import { utcToLocal } from "../../utils/dateConvert";
import DepotLiveAlertSubscriptions from "./DepotLiveAlertSubscriptions";

class EditDepot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      name: "",
      timeZoneArr: [],
      timeZoneName: "",
      description: "",
      error: false,
      timeZoneId: "",
      mapOverlay: "",
      id: "",
      suggestions: [],
      suggestionVisibility: false,
      searchText: "",
      lat: "",
      lng: "",
      customerError: false,
      nameError: false,
      descriptionError: false,
      timeZoneError: false,
      mapOverlayError: false,
      dbCreated: "",
      dbUpdated: "",
    };

    this.circleLat = "";
    this.circleLng = "";
    this.circleRad = "";

    this.rectLat1 = "";
    this.rectLat2 = "";
    this.rectLng1 = "";
    this.rectLng2 = "";

    this.polygonArr = [];
    this.type = "";
  }

  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Depots/SelectDepot/${this.props.match.params.id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setData(response.data);
      }
      console.log("response ", response.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    if (!this.props.readOnly) {
      this.getCustomers();
      this.getTimeZone();
    }
  }

  setData = (data) => {
    const {
      name,
      description,
      customerName,
      customerId,
      timeZonesId,
      timeZoneCity,
      mapOverlay,
      id,
      dbCreated,
      dbUpdated,
    } = data;

    this.setGraph(JSON.parse(mapOverlay));
    this.setState({
      name,
      description,
      customerName,
      timeZoneId: timeZonesId,
      timeZoneCity,
      timeZoneName: timeZoneCity,
      customerId,
      mapOverlay,
      id,
      dbCreated,
      dbUpdated,
    });
  };

  setGraph = (data) => {
    this.type = data.type;

    switch (data.type) {
      case "circle":
        this.circleLat = data.lat;
        this.circleLng = data.lng;
        this.circleRad = data.rad;
        break;
      case "polygon":
        this.polygonArr = this.handleArrRecreation(data.arr || []);
        break;
      case "rectangle":
        this.rectLat1 = data.lat1;
        this.rectLat2 = data.lat2;
        this.rectLng1 = data.lng1;
        this.rectLng2 = data.lng2;
        break;
      default: break;
    }
  };

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ customers: response.data });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getTimeZone = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ timeZoneArr: response.data });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleTimeZone = (evt) => {
    if (evt.target.value == "default") {
      this.setState({
        timeZoneError: true,
        timeZoneId: "",
        timeZoneName: "",
      });
    } else {
      this.setState({ timeZoneError: false });
    }
    this.state.timeZoneArr.forEach((time) => {
      if (time.timeZoneCity == evt.target.value) {
        this.setState({
          timeZoneId: time.timeZonesId,
          timeZoneName: time.timeZoneCity,
        });
      }
    });
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handleDescription = (evt) => {
    this.setState({ description: evt.target.value });
  };

  handleArrCreation = (data) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i] == 0) data.splice(i, 1);
    }
    var requiredArr = [];
    for (let i = 0; i < data.length; i += 2) {
      const coordinateObj = {
        lat: data[i],
        lng: data[i + 1],
      };
      requiredArr.push(coordinateObj);
    }

    return requiredArr;
  };

  handleArrRecreation = (data) => {
    var requiredArr = [];
    data.forEach((element) => {
      requiredArr.push(element.lat);
      requiredArr.push(element.lng);
      requiredArr.push(0);
    });

    return requiredArr;
  };

  handleCircleCreate = (data) => {
    this.circleLat = data.lat;
    this.circleLng = data.lng;
    this.circleRad = data.rad;
    this.type = "circle";
  };

  handlePolygonCreate = (data) => {
    this.polygonArr = data;
    this.type = "polygon";
  };

  handleRectangleCreate = (data) => {
    this.type = "rectangle";
    this.rectLat1 = data.lat1;
    this.rectLat2 = data.lat2;
    this.rectLng1 = data.lng1;
    this.rectLng2 = data.lng2;
  };

  handleCreate = async () => {
    const { name, description, customerId, timeZoneId, id } = this.state;
    const obb = {
      name: name,
      description: description,
      customerId: customerId,
      timeZonesId: timeZoneId,
      id: id,
    };

    var mapOverlayObj;

    switch (this.type) {
      case "circle":
        mapOverlayObj = {};
        mapOverlayObj.type = this.type;
        mapOverlayObj.lat = this.circleLat;
        mapOverlayObj.lng = this.circleLng;
        mapOverlayObj.rad = this.circleRad;

        obb.MapOverlay = JSON.stringify(mapOverlayObj);

        break;
      case "polygon":
        mapOverlayObj = {};
        mapOverlayObj.type = this.type;
        mapOverlayObj.arr = this.handleArrCreation(this.polygonArr);
        obb.MapOverlay = JSON.stringify(mapOverlayObj);

        break;
      case "rectangle":
        mapOverlayObj = {};
        mapOverlayObj.type = this.type;
        mapOverlayObj.north = this.rectLat1;
        mapOverlayObj.south = this.rectLat2;
        mapOverlayObj.west = this.rectLng1;
        mapOverlayObj.east = this.rectLng2;

        obb.MapOverlay = JSON.stringify(mapOverlayObj);

        break;
      default: break;
    }

    if (name && customerId && timeZoneId) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(`${apiHost}/api/Depots/Update`, obb, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (response.status == "200") {
          this.props.history.goBack();
        }
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = (obj) => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }
    if (!this.state.customerId) {
      this.setState({ customerError: true });
    }
    if (!this.state.timeZoneId) {
      this.setState({ timeZoneError: true });
    }
    if (!obj) {
      this.setState({ mapOverlayError: true });
    }
  };

  handleBack = () => {
    //this.props.history.push("/depots");
    this.props.history.goBack();
  };

  getOverlayLabel = () => {
    if (!this.type) {
      return "Map overlay";
    }

    return `${this.type.charAt(0).toUpperCase()}${this.type.slice(1)} overlay`;
  };

  // Map search and suggestions starts here
  handleLocationChange = (searchText) => {
    this.setState({ searchText });
    this.handleSearchSuggestion(searchText);
  };

    handleSearch = async () => {
        try {
            console.log("searec1", this.state.searchText);
            const { lat, lng } = await GeoCodeAPI(this.state.searchText);
            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });
            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    };

  handleSearchSuggestion = async (query) => {
    if (query != "") {
      this.setState({ suggestionVisibility: false });
    }
    this.setState({ suggestionVisibility: true });
      try {
          const items = await searchSuggestionAPI(query);
          this.setState({ suggestions: items });
      } catch (e) {
          console.log(e);
      }
  };
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ", event.target.value);
      this.handleSuggestionClick(event.target.value);
    }
  };
    handleSuggestionClick = async (place) => {
        var nwlocation = place.replace("<b>", "");
        var location = nwlocation.replace("</b>", "");

        this.setState({ searchText: location, suggestionVisibility: false });
        try {
            console.log("searecyy", location);
            const { lat, lng } = await GeoCodeAPI(location);
            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });
            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    };
  // Map search and suggestions ends here

  render() {
    const readOnly = !!this.props.readOnly;
    const isSystemAdmin = String(localStorage.getItem("role") || "")
      .replace(/\s+/g, "")
      .toLowerCase() === "systemadmin";
    const {
      timeZoneArr,
      customerName,
      timeZoneName,
      name,
      description,
      mapOverlay,
      lat,
      lng,
      customerError,
      nameError,
      timeZoneError,
      mapOverlayError,
    } = this.state;

    console.log("overlay point", mapOverlay);
    console.log("timeZoneName", timeZoneName);

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>{readOnly ? "View Depot" : "Edit Depot"} </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper depot-record-page">
              <div className="depot-record-header">
                <div>
                  <p className="depot-record-kicker">{readOnly ? "Depot view" : "Depot editor"}</p>
                  <h2>{name || (readOnly ? "View Depot" : "Edit Depot")}</h2>
                  <div className="depot-record-subtitle">
                    {customerName && <span>{customerName}</span>}
                    {timeZoneName && <span>{timeZoneName}</span>}
                    <span>{this.getOverlayLabel()}</span>
                  </div>
                </div>
                <div className="depot-record-actions">
                  <Button variant="light" onClick={this.handleBack}>
                    Back to List
                  </Button>
                  {!readOnly && <Button variant="primary" onClick={this.handleCreate}>
                    Save Changes
                  </Button>}
                </div>
              </div>

              <div className="depot-edit-layout">
                <Form className="depot-edit-form-modern">
                  <section className="depot-edit-section">
                    <div className="depot-edit-section-title">
                      <h3>Depot Details</h3>
                      <p>Customer ownership, depot name, timezone and description.</p>
                    </div>
                    <div className="depot-edit-grid">
                      <Form.Group className="depot-form-field" controlId="editDepotCustomer">
                        <Form.Label>Customer</Form.Label>
                        <Form.Control type="text" value={customerName || ""} disabled />
                        {customerError && (
                          <p className="depot-field-error">The Customer field is required.</p>
                        )}
                      </Form.Group>

                      <Form.Group className="depot-form-field" controlId="editDepotTimeZone">
                        <Form.Label>Time Zone</Form.Label>
                        {readOnly ? (
                          <Form.Control
                            type="text"
                            value={timeZoneName || "Not configured"}
                            disabled
                          />
                        ) : (
                          <Form.Control
                            as="select"
                            onChange={this.handleTimeZone}
                            value={timeZoneName}
                          >
                            <option value="default">Select Time Zone</option>
                            {timeZoneArr.map((timezone, index) => (
                              <option key={index}>{timezone.timeZoneCity}</option>
                            ))}
                          </Form.Control>
                        )}
                        {timeZoneError && (
                          <p className="depot-field-error">The Time Zone field is required.</p>
                        )}
                      </Form.Group>

                      <Form.Group className="depot-form-field" controlId="editDepotName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          onChange={this.handleName}
                          type="text"
                          value={name}
                          disabled={readOnly}
                        />
                        {nameError && (
                          <p className="depot-field-error">The Name field is required.</p>
                        )}
                      </Form.Group>

                      <Form.Group className="depot-form-field depot-edit-wide" controlId="editDepotDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows="4"
                          onChange={this.handleDescription}
                          value={description}
                          disabled={readOnly}
                        />
                      </Form.Group>

                      {this.state.error && (
                        <p className="error-text depot-save-error depot-edit-wide">
                          Please fill all the Required fields
                        </p>
                      )}
                    </div>
                  </section>

                  <section className="depot-edit-section depot-map-section">
                      <div className="depot-map-card-header">
                        <div>
                          <p className="depot-record-kicker">Map overlay</p>
                          <h3>Depot boundary</h3>
                          <p>{readOnly ? "Current depot geofence." : "Search for a location, then update the depot geofence on the map."}</p>
                        </div>
                        {mapOverlayError && (
                          <p className="depot-field-error">The Map field is required.</p>
                        )}
                      </div>
                      <div className="depot-record-card depot-map-card">
                        <div className="containerMapDepot">
                          <DepotMap
                            onCircleCreate={this.handleCircleCreate}
                            onPolygonCreate={this.handlePolygonCreate}
                            onRectangleCreate={this.handleRectangleCreate}
                            mapOverlay={mapOverlay}
                            lat={lat}
                            lng={lng}
                            readOnly={readOnly}
                          />
                          {!readOnly && <div className="overlaySearch">
                            <Col sm="12" className="inputSuggestions">
                              <Form.Control
                                value={this.state.searchText}
                                onChange={(e) =>
                                  this.handleLocationChange(e.target.value)
                                }
                                onKeyPress={(e) => this.handleKeyPress(e)}
                                autoComplete="off"
                                type="text"
                                placeholder="Search location"
                              />
                              {this.state.suggestionVisibility && (
                                <ul>
                                  {this.state.suggestions &&
                                    this.state.suggestions.map((item) => {
                                      return (
                                        <li
                                          key={item.address.label}
                                          onClick={() =>
                                            this.handleSuggestionClick(item.address.label)
                                          }
                                        >
                                          <HtmlContent html={item.address.label} />
                                        </li>
                                      );
                                    })}
                                </ul>
                              )}
                            </Col>
                          </div>}
                        </div>
                      </div>
                  </section>

                  {this.state.id && (
                    <DepotLiveAlertSubscriptions
                      depotId={this.state.id}
                      timeZoneId={this.state.timeZoneId}
                      systemAdmin={isSystemAdmin}
                    />
                  )}

                  <div className="depot-edit-meta">
                    <div>
                      <span>Created</span>
                      <strong>{this.state.dbCreated ? utcToLocal(this.state.dbCreated) : "Not created"}</strong>
                    </div>
                    <div>
                      <span>Updated</span>
                      <strong>{this.state.dbUpdated ? utcToLocal(this.state.dbUpdated) : "Not updated"}</strong>
                    </div>
                  </div>

                  <div className="depot-record-actions depot-edit-actions">
                    <Button variant="light" onClick={this.handleBack}>
                      Back to List
                    </Button>
                    {!readOnly && <Button variant="primary" onClick={this.handleCreate}>
                      Save Changes
                    </Button>}
                  </div>

                </Form>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditDepot);
